/* eslint complexity:0 */ // TODO PINT-4748
import { ACTION_TYPE, fetchJson } from '../../store/actionCreatorsHelpers';

interface Filters {
    [key: string]: {
        [key: string]: boolean;
    };
}

let sequence = 0;
export function fetchApps(filters: Filters, search: string, pageDomain?: string) {
    return {
        type: ACTION_TYPE.REQUEST_APPS,
        payload: fetchJson(`api/apps?${buildQuery(filters, search)}`),
        meta: { sequence: sequence++, pageDomain },
    };
}

function buildQuery(filters: Filters, search: string) {
    let activeFilters: string[];
    const queryParams = [];
    Object.keys(filters).forEach((filterGroup) => {
        activeFilters = [];
        Object.keys(filters[filterGroup]).forEach((filter) => {
            filters[filterGroup][filter] && activeFilters.push(filter);
        });
        activeFilters.length && queryParams.push(`${filterGroup}=${activeFilters.join()}`);
    });
    if (search && search.length >= 3) {
        queryParams.push(`search=${encodeURIComponent(search)}`);
    }

    return queryParams.join('&');
}
